module.exports = __webpack_public_path__ + "static/media/cruise06.f44464b4.png";